import { Mail, Phone, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/hooks/useLanguage";
import logo from "@/assets/logo.png";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { localePath } = useLanguage();

  const companyLinks = [
    { label: t("nav.about"), href: localePath("/") + "#about" },
    { label: t("nav.products"), href: localePath("/produkty") },
    { label: t("nav.contact"), href: localePath("/") + "#contact" },
  ];

  const productLinks = [
    { label: t("products.vertical"), href: localePath("/produkty") + "?kategorie=vertikalni" },
    { label: t("products.horizontal"), href: localePath("/produkty") + "?kategorie=horizontalni" },
    { label: t("products.compactors"), href: localePath("/produkty") + "?kategorie=kompaktory" },
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <a href={localePath("/")} className="flex items-center mb-4">
              <img src={logo} alt="EkoKompakt" className="h-10 w-auto" />
            </a>
            <p className="text-muted-foreground text-sm mb-6">
              EkoKompakt, s. r. o.<br />
              IČO: 08062684<br />
              Poznaňská 7, Brno, 616 00, Česká republika<br />
              {(i18n.language === 'cs' || i18n.language === 'sk') && (
                <>
                  <br />
                  Zastupujeme výrobce BartonTech v ČR a SR
                </>
              )}
            </p>
          </div>
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">{t("footer.company")}</h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">{t("footer.productsTitle")}</h3>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">{t("footer.contactTitle")}</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:+420724301099" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors text-sm">
                  <Phone className="w-4 h-4" />+420 724 301 099
                </a>
              </li>
              <li>
                <a href="mailto:info@ekokompakt.cz" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors text-sm">
                  <Mail className="w-4 h-4" />info@ekokompakt.cz
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-muted-foreground text-sm">
                  <MapPin className="w-4 h-4 mt-0.5" />
                  <span>{t("cta.addressValue")}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} EkoKompakt, s. r. o. {t("footer.rights")}
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">{t("footer.terms")}</a>
            <a href="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">{t("footer.privacy")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
